import { render, staticRenderFns } from "./GciLinkedMessage.vue?vue&type=template&id=65b0b748"
import script from "./GciLinkedMessage.vue?vue&type=script&lang=js"
export * from "./GciLinkedMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports